const $window = $(window);
const $header = $('.navbar');

const header = {
  initialize() {
    if ($header.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $('.js-has-dropdown').on('click', (e) => {
      e.preventDefault();

      const $el = $(`#${e.currentTarget.dataset.paramId}`);
      const isOpen = $el.hasClass('is-open');

      $('.js-navigation-dropdown').removeClass('is-open');

      $el.toggleClass('is-open', !isOpen);

      $('.js-submenu-item').addClass('mobile-display-none');
    });

    $('.js-navigation-back').on('click', (e) => {
      e.preventDefault();

      $('.js-submenu-item').removeClass('mobile-display-none');

      const $el = $('.js-navigation-dropdown');
      const isOpen = $el.hasClass('is-open');

      $el.toggleClass('is-open', !isOpen);
    });

    $('body').on('touchend', (e) => {
      const $el = $(e.target);
      const $parentOpenable = $el.parents('.js-header-openable');

      if (!$parentOpenable.length) {
        $('.js-header-openable.is-open').removeClass('is-open');
      }
    });

    $window.on('scroll:virtual', (e, scrollTop) => {
      this.scroll(scrollTop);
    });
  },

  scroll(top) {
    if (top > 30 && !$header.hasClass('is-scrolled')) {
      $header.addClass('is-scrolled');
    } else if (top <= 30 && $header.hasClass('is-scrolled')) {
      $header.removeClass('is-scrolled');
    }
  },
};

export default header;
